import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontWeightType, LabelMedium, LabelSmall } from '../../../../../component/Text';

const ReturnToRecommend:React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        cursor: 'pointer',
        justifyContent: 'center',
        display: 'flex',
        marginTop: 16,
      }}
      onClick={() => navigate(-1)}
    >
      <LabelSmall
        style={{
          color: '#333333', textDecorationColor: '#333333', textDecoration: 'underline', fontFamily: 'inter',
        }}
        fontWeight={FontWeightType.w800}
      >
        추천 목록으로 이동하기
      </LabelSmall>
    </div>
  );
};

export default ReturnToRecommend;
